<template>
  <modal
    :name="id"
    :adaptive="true"
    :height="485"
    :clickToClose="false"
  >
    <div class="sign-modal-content">
      <img
        src="@/assets/icons/close.svg"
        alt="close"
        class="close-button"
        @click="$modal.hide(id)"
      >

      <h1 class="fn-title-1 main-title">
        Активувати ключ (КЕП)
      </h1>

      <p class="sign-modal-subtitle">
        Під час роботи сервісу інформація, що міститься у файлах <br />
        користувача, оброблюється в браузері та не передається на <br />
        сторону надавача.
      </p>

      <!-- <ul class="tabs">
        <li
          class="item m-body-sb"
          :class="{ active: tab === 'file' }"
          v-on:click="changeTab('file')"
        >
          Файл на компьютері
        </li>
        <li
          class="item m-body-sb"
          :class="{
            active: tab === 'token',
            disabled: true
          }"
          v-on:click="changeTab('token')"
        >
          Токен
        </li>
      </ul> -->

      <div
        class="sign-modal-tab"
        v-if="tab === 'file'"
      >
        <DefaultSelect
          key="caId"
          class="sign-input"
          label="Кваліфікований надавач електронних довірчих послуг"
          name="caId"
          v-model="caId"
          v-bind:options="authorities"
          v-validate="'required'"
          :error="errors.has('caId')"
          :scroll="true"
        />

        <FileInput
          key="key"
          class="sign-input"
          label="Особистий ключ"
          name="key"
          v-model="key"
          id="file-input"
          v-validate="'required'"
          :error="errors.has('key')"
        />

        <DefaultInput
          key="password"
          class="sign-input"
          label="Пароль захисту ключа"
          type="password"
          name="password"
          v-model="password"
          v-validate="'required'"
          :error="errors.has('password')"
        />

        <div class="document-sign-buttons">
          <button
            class="main-btn second-color large-btn next-btn document-sign-button"
            @click="submit"
          >
            Зчитати
          </button>

          <a
            class="second-btn second-color large-btn next-btn howItWorks"
            href="https://wiki.legalaid.gov.ua/index.php/%D0%9F%D0%BE%D1%80%D1%8F%D0%B4%D0%BE%D0%BA_%D0%BE%D1%82%D1%80%D0%B8%D0%BC%D0%B0%D0%BD%D0%BD%D1%8F_%D0%BA%D0%B2%D0%B0%D0%BB%D1%96%D1%84%D1%96%D0%BA%D0%BE%D0%B2%D0%B0%D0%BD%D0%BE%D0%B3%D0%BE_%D0%B5%D0%BB%D0%B5%D0%BA%D1%82%D1%80%D0%BE%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE_%D0%BF%D1%96%D0%B4%D0%BF%D0%B8%D1%81%D1%83"
            rel="noopener noreferrer"
            target="blank"
          >
            Як це працює?
          </a>
        </div>

      </div>

    </div>
  </modal>
</template>

<script>
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'
import DefaultSelect from '@/components/Ui-new/DefaultSelect.vue'
import FileInput from '@/components/Ui-new/FileInput.vue'

export default {
  name: 'DocumentsSignModal',
  components: {
    DefaultInput,
    DefaultSelect,
    FileInput
  },
  methods: {
    changeTab (tab) {
      this.tab = tab
    },
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true

            this.$emit('submit', {
              caId: this.caId.optionId,
              key: this.key,
              password: this.password
            })
          }
        })
        .then(() => {
          this.password = null
        })
    }
  },
  data () {
    return {
      tab: 'file',

      caId: null,
      key: null,
      password: null
    }
  },
  props: ['id', 'authorities']
}
</script>

<style lang="less" scoped>
.sign-modal-content {
  padding: 40px;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
.sign-modal-tab {
  display: flex;
  flex-flow: column wrap;
}
.sign-input {
  margin-bottom: 20px;
}
.document-sign-buttons {
  display: flex;
}
.document-sign-button {
  margin-right: 8px;
}

.default-select.sign-input .items {
  height: 150px;
  overflow-y: auto;
}
.tabs .item {
  flex-grow: 1;
}
.howItWorks {
  color: var(--main-hover);
  text-decoration: none;
}
.close-button {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}
</style>
